import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Textarea } from '@/components/ui/textarea';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import { api } from '@/lib/api';
import { useI18n } from '@/context/I18nContext';

const REASONS = [
    { value: 'spam', label_es: 'Spam / duplicado' },
    { value: 'prohibited', label_es: 'Producto prohibido' },
    { value: 'counterfeit', label_es: 'Producto falsificado' },
    { value: 'scam', label_es: 'Estafa / fraude' },
    { value: 'offensive', label_es: 'Contenido ofensivo' },
    { value: 'harassment', label_es: 'Acoso al usuario' },
    { value: 'wrong_category', label_es: 'Categoría incorrecta' },
    { value: 'copyright', label_es: 'Derechos de autor' },
    { value: 'other', label_es: 'Otro motivo' },
];

export const ReportModal = ({ open, onOpenChange, targetType, targetId, targetTitle }) => {
    const { t } = useI18n();
    const [reason, setReason] = useState('scam');
    const [description, setDescription] = useState('');
    const [evidence, setEvidence] = useState('');
    const [busy, setBusy] = useState(false);

    const submit = async () => {
        if (description.length < 5) { toast.error('Describe el problema con al menos 5 caracteres'); return; }
        setBusy(true);
        try {
            await api.post('/reports', { target_type: targetType, target_id: targetId, reason, description, evidence_url: evidence || null });
            toast.success('Reporte enviado, gracias por ayudarnos a mantener el marketplace seguro.');
            onOpenChange(false);
            setDescription(''); setEvidence(''); setReason('scam');
        } catch (e) {
            toast.error(e?.response?.data?.detail || 'No se pudo enviar el reporte');
        } finally { setBusy(false); }
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-md">
                <DialogHeader>
                    <DialogTitle>{t('report.title','Reportar')} {targetType === 'ad' ? 'anuncio' : targetType}</DialogTitle>
                    <DialogDescription>{targetTitle || 'Ayúdanos a revisar este contenido.'}</DialogDescription>
                </DialogHeader>
                <div className="space-y-3">
                    <div>
                        <Label>{t('report.reason','Motivo')}</Label>
                        <Select value={reason} onValueChange={setReason}>
                            <SelectTrigger data-testid="report-reason"><SelectValue /></SelectTrigger>
                            <SelectContent>
                                {REASONS.map(r => <SelectItem key={r.value} value={r.value}>{r.label_es}</SelectItem>)}
                            </SelectContent>
                        </Select>
                    </div>
                    <div>
                        <Label>{t('report.description','Descripción')}</Label>
                        <Textarea value={description} onChange={e => setDescription(e.target.value)} rows={4} placeholder="Describe con detalle el problema…" data-testid="report-description" />
                    </div>
                    <div>
                        <Label>URL de evidencia (opcional)</Label>
                        <Input value={evidence} onChange={e => setEvidence(e.target.value)} placeholder="https://…" data-testid="report-evidence" />
                    </div>
                </div>
                <DialogFooter>
                    <Button variant="outline" onClick={() => onOpenChange(false)}>{t('action.cancel','Cancelar')}</Button>
                    <Button onClick={submit} disabled={busy} data-testid="report-submit" className="bg-red-600 hover:bg-red-700">{busy ? '…' : t('report.submit','Enviar reporte')}</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};
